import React from 'react';

/* packages */
import DesignSection from '../../util-mui-design-section';
/* packages */

const Index = props => {
  return <DesignSection.Title>
    Edit Contact
  </DesignSection.Title>
}

export default Index;
